import {
  FilterSelector,
  Heading,
  HStack,
  VStack,
} from '@ayble-health/dashboard-components';
import React from 'react';
import { Drawer } from '../../Drawer';
import { BlockType } from '../../../models/block';
import { BlockDrawerContent } from './BlockDrawerContent';
import { useOverviewPage } from './hooks/useOverviewPage';
import VisitBlock from './VisitBlock';
import { archivedFilterOptions, laneLabelByType } from './constants';
import GutCheckCountCard from './GutCheckCountCard';
import SymptomScoreCard from './SymptomScoreCard';
import PatientOverviewTabsBlock from './PatientOverviewTabsBlock';
import { ProviderType } from '../../../api/types';
import BlockLane from 'components/UserDashboard/overview/BlockLane';

type Props = {
  onOpenAppointments: (providerType?: ProviderType) => void;
  setActiveIndex?: (activeIndex: number) => void;
};

export const OverviewPage = ({ onOpenAppointments, setActiveIndex }: Props) => {
  const {
    drawerHeader,
    drawerSubtitle,
    isBlockDrawerOpen,
    closeBlockDrawer,
    handleUpdateUserBlock,
    handleUserBlockAction,
    onBackToBlockList,
    onCreateBlock,
    onPatientInstructionsChange,
    onSelectBlock,
    openCreateBlockDrawer,
    openEditBlockDrawer,
    openNutritionBlockDetailsDrawer,
    patientInstructions,
    selectedBlock,
    selectedLaneBlock,
    archivedFilter,
    setArchivedFilter,
  } = useOverviewPage();

  return (
    <>
      <VStack px={6} pb={6}>
        <HStack alignItems={'stretch'} gap={4} mb={8}>
          <VStack flexGrow={2} gap={4} w={'60%'}>
            <PatientOverviewTabsBlock openEditBlockDrawer={openEditBlockDrawer} />
            <HStack gap={4} w={'100%'}>
              <SymptomScoreCard onClick={() => setActiveIndex?.(1)} />
              <GutCheckCountCard />
            </HStack>
          </VStack>
          <VisitBlock onOpenAppointments={onOpenAppointments} />
        </HStack>

        <HStack justifyContent="space-between" w="100%" mb={4} alignItems="center">
          <Heading
            color={'secondary.500'}
            fontSize={'2xl'}
            fontWeight={'normal'}
            textAlign={'left'}
          >
            Care Guide
          </Heading>
          <FilterSelector
            options={archivedFilterOptions}
            selected={archivedFilter}
            onChange={setArchivedFilter}
          />
        </HStack>

        <HStack alignItems={'flex-start'} overflow={'auto'} pb={1} gap={4}>
          {(Object.entries(laneLabelByType) as [BlockType, string][]).map(
            ([blockType, laneTitle]) => {
              return (
                <BlockLane
                  archived={archivedFilter.value}
                  blockType={blockType}
                  title={laneTitle}
                  openEditBlockDrawer={openEditBlockDrawer}
                  openCreateBlockDrawer={openCreateBlockDrawer}
                  openNutritionBlockDetailsDrawer={
                    openNutritionBlockDetailsDrawer
                  }
                  handleUserBlockAction={handleUserBlockAction}
                />
              );
            }
          )}
        </HStack>
      </VStack>

      <Drawer
        bgColor={'white'}
        isOpen={isBlockDrawerOpen}
        onClose={closeBlockDrawer}
        showBackButton={false}
        showExternalCloseHandle={false}
        showHeader={false}
        renderContent={() => (
          <BlockDrawerContent
            editableBlock={selectedLaneBlock}
            onBackToBlockList={onBackToBlockList}
            onCreateBlock={onCreateBlock}
            onPatientInstructionsChange={onPatientInstructionsChange}
            onSelectBlock={onSelectBlock}
            patientInstructions={patientInstructions}
            selectedBlock={selectedBlock}
            handleUpdateUserBlock={handleUpdateUserBlock}
            handleUserBlockAction={handleUserBlockAction}
            closeBlockDrawer={closeBlockDrawer}
            drawerSubtitle={drawerSubtitle}
            drawerHeader={drawerHeader}
          />
        )}
      />
    </>
  );
};
